import { Injectable } from '@angular/core';

import {
  Action,
  DpuLoadFileType,
  DpuStateKey,
  LayoutActionType,
  LayoutState,
  Reducer,
  Store,
} from '@olympus/ngx-shared';

import { WindViewPreference } from '../../app.preference';
import { WindViewState } from '../../app.state';

export enum DPUActionType {
  FILE_SELECTED = 'FileSelected',
  LAYOUT_CHANGE = 'LayoutChange',
}

@Injectable({
  providedIn: 'root',
})
export class DPUReducer implements Reducer {
  constructor(
    private readonly _state$: WindViewState,
    private readonly _layoutState$: LayoutState,
    private readonly _store: Store,
    private readonly _preferenceService: WindViewPreference,
  ) { }

  public async reduce(action: Action): Promise<void> {
    const loadFile: DpuLoadFileType = this._state$.instant(DpuStateKey.DPU_LOAD_FILE).value;

    switch (action.type) {
      case LayoutActionType.GROUPS_LAYOUTS_GROUPS:
        this._state$.patch(DpuStateKey.DPU_LOAD_FILE, {
          ...loadFile,
          previousGroupId: loadFile.currentGroupId,
          currentGroupId: action.payload?.value,
        });

        break;

      case DPUActionType.FILE_SELECTED:
        if (this._layoutState$.instant('IsFullWindow').value) {
          this._preferenceService.patch('LayoutList', this._preferenceService.instant('LayoutList').filter(layout => layout.isFullWindow !== true));
          this._layoutState$.patch('IsFullWindow', false);
          this._layoutState$.patch('CurrentLayoutId', this._layoutState$.instant('PreviousLayoutId').value);
          this._layoutState$.patch('PreviousLayoutId', undefined);
        }

        this._store.dispatch({
          type: 'OPEN_FILE', payload: {
            filePathName: action.payload,
            layoutName: this._layoutState$.instant('CurrentLayoutId').value,
          },
        });

        break;

      default:
        break;
    }
  }
}
